<template>
  <div class="labeled-city-selector">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <CitySelector
      ref="citySelector"
      :id="inputId"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      :is-foreign-country="isForeignCountry"
      :foreign-country-label="foreignCountryLabel"
      :empty-text="emptyText"
      :error-messages="errorMessages"
      :value="value"
      @beforeChange="onBeforeChange"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <slot />
    </CitySelector>
  </div>
</template>

<script>
import CitySelector from '../city-selector';
import { RandomId } from '@/shared/lib/random';
import { InputLabel } from '@/shared/ui/form';

const { generateRandomId } = RandomId();

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: ''
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isForeignCountry: {
      type: Boolean,
      default: false,
    },
    foreignCountryLabel: {
      type: String,
      default: 'Іноземна країна',
    },
    emptyText: {
      type: String,
      default: 'No options available',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inputId: `input-text-${this.generateRandomId()}`,
    };
  },
  components: { InputLabel, CitySelector },
  computed: {
    getCitiesList() {
      return this.$refs.citySelector.getCitiesList;
    },
    getCitySelector() {
      return this.$refs.citySelector;
    }
  },
  methods: {
    generateRandomId,
    onBeforeChange(newValue, oldValue) {
      this.$emit('beforeChange', newValue, oldValue);
    },
  },
};
</script>
